import React from 'react';
import './loadingmask.css';


export default (props)=>{
  let cn = props.show ? 'loading-mask' : 'hidden';
  return (
    <div className={cn}>
        <i className="fas fa-spinner fa-pulse fa-4x"/>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/common/LoadingMask.js